import React from "react";
import {ArrowRightIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";
import {useTypedSelector} from "helpers/reducers";
import Loader from "components/Loader";

interface FooterSidebarLeftProps {
}

const FooterSidebarLeft = (props: FooterSidebarLeftProps) => {
    const {t} = useTranslation();
    const hall = useTypedSelector(state => state.hallState.hall);

    if (!hall) {
        return <Loader />;
    }

    return (
        <div className={"FooterSidebarLeft w-auto flex flex-col gap-y-4 md:gap-y-6 text-left"}>
            <h2 className={"font-zuume font-bold text-[32px]"}>{t("Address")} / {t("Contact")}</h2>

            <div>
                <p>
                    <span className={"font-bold"}>{hall.name}</span>
                    <br />
                    <span>Textilstrasse 7</span>
                    <br />
                    <span>9320 Arbon</span>
                </p>
            </div>

            <div>
                <p>
                    <a
                        className={"font-bold inline-flex items-center text-center w-auto gap-2 transform-gpu duration-150 transition-all cursor-pointer text-white hover:text-arbo-red"}
                        href={"https://maps.app.goo.gl/YNYb3iz9BxUB7mS36"}
                        rel={"noreferrer"}
                        target={"_blank"}
                    >
                        <span>{t("Open in Google Maps")}</span>
                        <ArrowRightIcon className={"flex-none size-4"} />
                    </a>
                </p>
            </div>

            <div>
                <p>
                    <a className={"text-arbo-yellow hover:text-arbo-orange"} href={`tel:${hall.contact}`}>{hall.contact}</a>
                </p>
            </div>

            <div>
                <p>
                    <a className={"text-arbo-yellow hover:text-arbo-orange"} href={`mailto:${hall.email}`}>{hall.email}</a>
                </p>
            </div>
        </div>
    );
};

export default FooterSidebarLeft;